import React from 'react'
import s from './Introduction.less'

export const Introduction = ({ h1, h2, children }) => (
  <div className={s.root}>
    <h1 className={s.h1}>{h1}</h1>
    <h2 className={s.h2}>{h2}</h2>
    {children}
  </div>
)

export const IntroductionWithLinks = ({ h1, h2, links }) => (
  <Introduction h1={h1} h2={h2}>
    <ul className={s.list}>
      {links.map(({ url, label }, index) => (
        <li className={s.listItem} key={index}>
          <a className={s.link} href={url}>
            {label}
          </a>
        </li>
      ))}
    </ul>
  </Introduction>
)
